import { useAppBarFarGearMenuItem, } from './builtInItem/useAppBarFarGearMenuItem';
import { compact, concat } from 'lodash';
import { getFeedbackMenuItem, } from './builtInItem/premadeItem';
/** Hook that generates the utilities menu on the right side of the app bar. */
export const useAppBarFarItems = ({ farItems, gearMenuItemList, isInternalPortal, supportFormUrl, stringsFarItems: { stringsFeedbackItem, stringsPreviewItem, stringsPrivacyItem, stringsThemeItem, } = {}, }) => {
    const feedbackItem = Object.assign(Object.assign({}, getFeedbackMenuItem({ href: supportFormUrl, stringsFeedbackItem })), { iconOnly: true });
    const gearMenuItem = useAppBarFarGearMenuItem({
        items: gearMenuItemList,
        isInternalPortal,
        supportFormUrl,
        stringsGearMenu: {
            stringsFeedbackItem,
            stringsPreviewItem,
            stringsPrivacyItem,
            stringsThemeItem,
        },
    });
    return compact(concat(farItems, [feedbackItem, gearMenuItem]));
};
